module.exports = __webpack_public_path__ + "f0dc367a7742023beaed836917644e35.MP3";